<div *transloco="let t; prefix: 'project'" class="container mx-auto">
  <app-background-card
    [title]="t('overviewHeader')"
    titleTestId="project-list-header"
    testId="project-list-container"
    [actionLabel]="
      !loading() && displayedProjects().length && roleCheckService.hasCustomerAdminRole()
        ? t('setup')
        : ''
    "
    actionTestId="setup-project-button"
    (actionClick)="router.navigate([APP_ROUTES.PROJECT + APP_ROUTES.CREATE])"
  >
    <div class="mb-4">
      @if (loading()) {
        <app-loading />
      } @else {
        @if (hasArchived()) {
          <div class="flex items-center mt-2 space-x-2 mb-2">
            <p-toggleswitch
              (ngModelChange)="showArchived.set($event)"
              [ngModel]="showArchived()"
              inputId="showArchived"
              data-testId="show-archived-switch"
            />

            <label class="select-none text-sm" for="showArchived" data-testId="show-archived-label">
              {{ t('filter.showArchived') }}
            </label>
          </div>
        }
        @if (emptyState(); as empty) {
          <div
            [attr.data-testid]="empty.testId"
            class="flex flex-col items-center text-center p-8 gap-4"
          >
            <i class="pi pi-file-plus text-6xl! text-primary"></i>
            <h3 class="text-lg font-semibold text-gray-400">{{ empty.title }}</h3>
            @if (empty.buttonLabel) {
              <p-button
                (onClick)="empty.clickHandler()"
                [attr.data-testid]="empty.buttonTestId"
                [label]="empty.buttonLabel"
                [disabled]="offices().length > 0 && !(isContractActive() && hasModuleFunctions())"
                styleClass="px-8!"
              ></p-button>
            }
          </div>
        } @else {
          <app-project-list
            [projects]="displayedProjects()"
            [projectUserDetails]="projectUserDetails()"
            (archiveProjectEvent)="onChildArchive($event)"
            (deleteProjectEvent)="onChildDelete($event)"
            (copyProjectEvent)="onChildCopy($event)"
            (editProjectEvent)="onChildEdit($event)"
            (goToProjectEvent)="goToProject($event)"
            (invitationResponseEvent)="onInvitationResponse($event.projectId, $event.accept)"
          ></app-project-list>
        }
      }
    </div>
  </app-background-card>
  @if (!loading() && emptyState() && !(isContractActive() && hasModuleFunctions())) {
    <div
      class="mt-24 w-screen absolute left-0 items-center border-t-4 border-b-4 border-red-400 rounded-none! ng-star-inserted bg-(--p-card-background)"
    >
      <div class="flex justify-center items-center text-start p-8 gap-4">
        {{ 'project.overview.disabled.disclaimer' | transloco }}
      </div>
    </div>
  }
  <app-project-copy-dialog
    [visible]="copyDialogVisible()"
    (visibleChange)="copyDialogVisible.set($event)"
    (confirmed)="onCopyConfirmed($event)"
  ></app-project-copy-dialog>
</div>
